<template>
  <div class="osk-cart-empty">
    <div class="osk-cart-empty__text">
      {{ $t('components.cart.cartEmpty.text') }}
    </div>

    <div class="osk-cart-empty__buttons">
      <UikitButton
        to="/"
        outline
        size="s"
        class="osk-cart-empty__button"
      >
        {{ $t('components.cart.cartEmpty.toMain') }}
      </UikitButton>

      <template v-if="account.id">
        <UikitButton
          :to="`/profile/${account.id}/wishlist`"
          outline
          size="s"
          class="osk-cart-empty__button"
        >
          {{ $t('components.cart.cartEmpty.toWishList') }}
        </UikitButton>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { account } = useAccountStore();
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-cart-empty {
  @media screen and (min-width: 580px) {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__text {
    max-width: 260px;
    padding-bottom: $indent-mlarge;
  }

  &__buttons {
    display: flex;
    align-items: center;

    @media screen and (min-width: 580px) {
      justify-content: center;
    }
  }

  &__button {
    width: 230px;

    & + & {
      margin-left: $indent-compact;
    }
  }
}
</style>
